import { useContext } from 'react';
import { ConfigContext } from '../providers/ConfigContext';
import useMakeApiRequest from '../utils/makeApiRequest';

const useSendEmail = () => {
	const { apiBase } = useContext(ConfigContext);
	const makeApiRequest = useMakeApiRequest('POST');

	const sendEmail = async (transactionId: any, body: any, fairid?: any) => {
		let url = `${apiBase}/api/transactions/${transactionId}/email`;
		if (fairid) {
			url += `?fairId=${fairid}`;
		}
		return makeApiRequest(url, body);
	};
	return [sendEmail];
};

export default useSendEmail;
